import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewYearDecorationComponent } from './new-year-decoration.component';
import { NewYearAudioContextService } from './service/new-year-audio-context.service';
import { NewYearBallsService } from './service/new-year-balls.service';
import { NewYearSoundsLoaderService } from './service/new-year-sounds-loader.service';

@NgModule({
  declarations: [NewYearDecorationComponent],
  imports: [CommonModule],
  exports: [NewYearDecorationComponent],
  providers: [NewYearAudioContextService, NewYearBallsService, NewYearSoundsLoaderService],
})
export class NewYearDecorationModule {}
